module.exports = __webpack_public_path__ + "img/3f_r_pizzala.ca12705a.jpg";